<template>
    <li
        :class="[tagClasses]"
        class="w-fit flex gap-1 items-center rounded-6 text-white py-4 px-12 font-semibold text-body-sm"
        @click="handleClick"
    >
        <svg-icon
            v-if="iconType && !iconAfter"
            class="w-18 h-18"
            :type="iconType"
        />
        <slot></slot>
        <svg-icon
            v-if="iconType && iconAfter"
            class="w-18 h-18"
            :type="iconType"
        />
    </li>
</template>
<script>
import SvgIcon from './SvgIcon.vue';
export default {
    components: {
        'svg-icon': SvgIcon,
    },
    name: "Tag",
    props: {
        display: {
            type: String,
            default: 'primary',
            validator: value => [
                'primary',
                'secondary',
                'success',
                'warning',
                'info',
                'danger',
            ].includes(value),
        },
        interactive: Boolean,
        disabled: Boolean,
        icon: String,
        iconAfter: Boolean,
        noIcon: Boolean,
    },
    data() {
        return {
            enabledClasses: {
                primary: 'bg-primary',
                secondary: 'bg-secondary',
                success: 'bg-semantic-success',
                warning: 'bg-semantic-warning',
                info: 'bg-semantic-info',
                danger: 'bg-semantic-error',
            },
            disabledClasses: {
                primary: 'bg-primary-40',
                secondary: 'bg-secondary-60',
                success: 'bg-semantic-success',
                warning: 'bg-semantic-warning',
                info: 'bg-semantic-info',
                danger: 'bg-semantic-error',
            }
        }
    },
    computed: {
        iconVisibility() {
            return (['success', 'warning', 'info', 'danger'].includes(this.display) && !this.noIcon) || this.icon
        },
        iconType() {
            if (!this.iconVisibility) {
                return null;
            }
            if (this.icon) {
                return this.icon;
            } else {
                switch (this.display) {
                    case 'success':
                        return 'check-circle';
                    case 'warning':
                        return 'warning';
                    case 'info':
                        return 'info';
                    case 'danger':
                        return 'error';
                }
            }
            return null;
        },
        tagClasses() {
            let defaultClasses = this.disabled ? this.disabledClasses[this.display] : this.enabledClasses[this.display];

            if (this.disabled) {
                return defaultClasses;
            }

            if (this.interactive) {
                defaultClasses += ' cursor-pointer';
                if (this.display === 'primary') {
                    defaultClasses += ' hover:bg-primary-80';
                }
            } else {
                defaultClasses += ' cursor-default';
            }
            return defaultClasses;
        },
    },
    methods: {
        handleClick() {
            if (this.interactive && !this.disabled) {
                this.$emit('click');
            }
        }
    }
}
</script>
<style scoped>

</style>